import { render } from "./GenericSlider.vue?vue&type=template&id=04b6840d&scoped=true&ts=true"
import script from "./GenericSlider.vue?vue&type=script&lang=ts"
export * from "./GenericSlider.vue?vue&type=script&lang=ts"

import "./GenericSlider.vue?vue&type=style&index=0&id=04b6840d&lang=scss&scoped=true"

import exportComponent from "/home/satou/deinjobfuchs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04b6840d"]])

export default __exports__